import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import Sortable      from 'react-sortablejs';
import ContentsModal from 'contents_modal';

import Card             from '@common/influencer/_card';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------

class ProgressSpace extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal : false,
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    
    let Items = {};
    for( let i in base.workflow.influencers ){
      let d = base.workflow.influencers[i];
      
      try {
        if( Object.keys(d.status).length > 0 && d.status.is_client_check == 1 ){
          let date = (d.status.recommend_date == null) ? null : Utils.setDate(d.status.recommend_date, 'YYYY/M/D HH:mm');
          if( Items[date] == undefined ) Items[date] = { list: [], date: date, recommend_text: d.status.recommend_text, unix: Moment(d.status.recommend_date).unix() };
          
          d.sort_score = 0;
          if( d.status.is_client_check_complete == 1 ) d.sort_score = 1;
          if( d.is_ng == 1 ) d.sort_score = -1;
          
          Items[date].list.push(d);
          if( isNaN(Items[date].unix) == true ) Items[date].unix = 0;
        }
      } catch(e) {}
    }
    
    let itemAry = [];
    for( let i in Items ) itemAry.push(Items[i]);
    itemAry = Utils.sort(itemAry, 'unix', 'asc');
    
    itemAry = itemAry.map((d) => {
      d.list = Utils.sort(d.list, 'sort_score', 'desc');
      return d;
    });
    
    return (
      <div className="client-check-history-modal">
        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>クライアントチェックの履歴を表示</Tooltip>}>
          <i className="history-button material-icons" onClick={this.toggleModal.bind(this, true)}>history</i>
        </OverlayTrigger>
        
        { (this.state.modal == true) &&
          <ContentsModal
            view      = {this.state.modal}
            width     = {'calc(100% - 100px)'}
            height    = {'calc(100% - 100px)'}
            close_ev  = {this.toggleModal.bind(this, false)}
            html      = {
              <div className="modal-item">
                <h1>クライアントチェックの履歴</h1>
                
                <ul>
                  { itemAry.map((d, key) => {
                    return (
                      <li key={key}>
                        { (d.date != null) && <p className="date">{d.date}</p> }
                        { (d.recommend_text != null) && <p className="recommend_text">「{d.recommend_text}」</p> }
                        
                        <div className="influencers">
                          { d.list.map((i, ikey) => {
                            return (
                              <div key={ikey} className="influencers-item">
                                <Card data={i} base={base} />
                                
                                { (i.status.is_client_check_complete == 1 && i.is_ng == 0) &&
                                  <p className="check-item check-ok">確認OK</p>
                                }
                                { (i.status.is_client_check_complete == 1 && i.is_ng == 1) &&
                                  <p className="check-item check-ng">確認NG</p>
                                }
                                { (i.status.is_client_check_complete == 0) &&
                                  <p className="check-item check-now">チェック中</p>
                                }
                              </div>
                            );
                          })}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            }
          />
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressSpace;